<template>
	<CCard>
		<CCardHeader>
			<h5>Echanges avec le client</h5>
		</CCardHeader>
		<div ref="chat" class="chat-container">
			<template v-for="message in ticket.messages">
				<MessageBubble
					:author="
						message.createdBy.role === 'ROLE_USER' || message.createdBy.role === 'ROLE_CUSTOMER'
							? 'Client'
							: message.createdBy.email
					"
					:created-at="message.createdAt"
					:message="message.content"
					:is-author="
						message.createdBy.role !== 'ROLE_USER' && message.createdBy.role !== 'ROLE_CUSTOMER'
					" />
			</template>
		</div>

		<div class="p-3">
			<form ref="messageForm" action="/api/support_messages" method="POST" axiosMethod="post">
				<CTextarea
					label="Votre message"
					name="content"
					v-model="message"
					placeholder="Entrez votre message" />
				<CInput type="hidden" name="supportTicket" :value="ticket['@id']" />
			</form>
			<GLoadingButton
				:loading="loading"
				@click="onSubmit($refs.messageForm)"
				class="btn-submit float-right"
				color="success"
				label="Envoyer" />
		</div>
	</CCard>
</template>

<script>
	import MessageBubble from './MessageBubble';
	import GLoadingButton from '../../../../../components/ghostlexly-components/GLoadingButton';

	export default {
		name: 'ChatCard',
		components: { GLoadingButton, MessageBubble },
		props: {
			ticket: Object,
			isAdmin: Boolean,
		},
		data() {
			return {
				message: null,
				loading: false,
			};
		},
		methods: {
			onSubmit(form) {
				this.loading = true;
				this.$formDataToApi.sendForm(form).then(res => {
					this.loading = false;

					if (res.status === 200 || res.status === 201) {
						this.$toast.success('Message envoyé !');
						this.$emit('new:message', res.data);
						this.$nextTick(() => this.$refs.chat.scrollTo(0, this.$refs.chat.scrollHeight));
					}

					this.message = null;
				});
			},
		},
		mounted() {
			this.$refs.chat.scrollTo(0, this.$refs.chat.scrollHeight);
		},
	};
</script>

<style>
	.chat-container {
		display: flex;
		flex-direction: column;
		padding: 20px;
		overflow-y: scroll;
		height: 218px;
	}

	.btn-submit {
		width: fit-content;
		align-self: flex-end;
	}

	.justify-self-end {
		justify-self: flex-end;
	}
</style>
